import HTTPService from '@/api/base/HTTPService'

// grain-core serves the catering order + capacity APIs as a PUBLIC API
// (`/api/public/v1/*`) — no client secret in the browser. It's public-by-design;
// abuse is handled server-side (rate limiting, idempotency, server-side price/
// menu validation, etc.), not by a key. Same V1-shaped request/response as
// Papercut. PROVISIONAL — endpoints not built yet; the public surface must have
// those controls before the flag is enabled (GRAIN-2156 / GRAIN-2158).
const GRAIN_CORE_API_VERSION_ROOT = '/api/public/v1'

if (!process.env.VUE_APP_GRAIN_CORE_URL) {
  // Without the URL the base degrades to "undefined/api/public/v1". The flag
  // defaults off so prod is unaffected, but warn so misconfigured local/dev
  // envs are easy to diagnose before the flag is flipped.
  // eslint-disable-next-line no-console
  console.warn('[GrainCoreApi] VUE_APP_GRAIN_CORE_URL is not set — grain-core calls would hit "undefined/api/public/v1". Set it before enabling the cateringOrdersViaGrainCore flag.')
}

export const GRAIN_CORE_API_URL = `${process.env.VUE_APP_GRAIN_CORE_URL}${GRAIN_CORE_API_VERSION_ROOT}`

// Catering order + capacity paths owned by this backend (mirrors the Papercut
// surface; same request/response).
export const GRAIN_CORE_CATERING_PATHS = {
  orders: () => `${GRAIN_CORE_API_URL}/orders`,
  orderReferredBy: (orderId) => `${GRAIN_CORE_API_URL}/orders/${orderId}/referred_by`,
  timeSlots: (date) => `${GRAIN_CORE_API_URL}/time_slots/${date}`,
  closedHours: () => `${GRAIN_CORE_API_URL}/closed_hours`,
  locationConfigs: () => `${GRAIN_CORE_API_URL}/location_configs`,
  salesRepresentatives: () => `${GRAIN_CORE_API_URL}/sales_representatives`
}

const PLATFORM = 'catering'

const GrainCoreApi = HTTPService()
GrainCoreApi.setup({
  getPlatform() {
    return PLATFORM
  }
  // No auth header: grain-core catering is a public API. No client secret is
  // shipped in the browser; the server enforces abuse controls instead.
})
export default GrainCoreApi
